import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';
import {buildPaymentDocumentsPatchBody} from './buildPaymentDocumentsPatchBody';

export function buildDocumentsPatchBody(
  documents: WarehouseDirectSaleVariantsDetailFormSchemaType['documents']
) {
  return {
    ...documents,
    ...buildPaymentDocumentsPatchBody(documents),
    fastTrackIssue: {
      ...documents.fastTrackIssue,
      // Set both templateId and docSeriesId to null when fastTrack is disabled
      templateId: documents.fastTrackIssue.isEnable
        ? documents.fastTrackIssue.templateId || undefined
        : null,
      docSeriesId: documents.fastTrackIssue.isEnable ? documents.fastTrackIssue.docSeriesId : null,
    },
    // Convert empty strings to undefined for optional orderOffer fields
    orderOffer: {
      ...documents.orderOffer,
      templateId: documents.orderOffer?.templateId || undefined,
      docSeriesId: documents.orderOffer?.docSeriesId || undefined,
    },
  };
}
